// removed by extract-text-webpack-plugin
module.exports = {"contentBox":"_2QhTLSKsNi4ortpEMQmdyd","boxTitle":"JW9z7Qe-N8Gay_IeNrFuA","collapsable":"_2sSdYCSY-lwCb9y9IlkebZ","collapsed":"_18a5feK4oDSeZbrvCRB13i","arrow":"_3wjzbjU8-kkir9hhX3WqER","up":"_2yxsm5ngxO2G4zGR_QtYMI","down":"ao7cyQUc4xC7xzyyjtE6J"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/ContentBox.scss
// module id = 385
// module chunks = 0